import React from 'react';
import { Icon } from '@iconify/react';

type ReceiptAuditStatusIconProps = {
  status: string;
};

const ReceiptAuditStatusIcon: React.FC<ReceiptAuditStatusIconProps> = ({ status }) => {
  switch (status) {
    case 'completed':
      return <Icon icon="ion:hourglass-outline" width="24" height="24" style={{ color: "#FF8D28" }} />;
    case 'finalized':
      return <Icon icon="material-symbols:done-all-rounded" width="24" height="24" style={{ color: "#05BE43" }} />;
    case 'auto_finalized':
      return <Icon icon="material-symbols:smart-toy-outline" width="24" height="24" style={{ color: "#00A3A3" }} />;
    case 'processing':
      return <Icon icon="material-symbols:cached-rounded" width="24" height="24" style={{ color: "#2C6CA0" }} />;
    case 'ready':
      return <Icon icon="material-symbols:done-rounded" width="24" height="24" style={{ color: "#05BE43" }} />;
    case 'failed':
      return <Icon icon="maki:cross" width="24" height="24" style={{ color: "#FF0000" }} />;
    case 'rejected':
      return <Icon icon="mdi:cancel" width="24" height="24" style={{ color: "#FF0000" }} />;
    case 'queued':
      return <Icon icon="mdi:receipt-text-pending" width="24" height="24" style={{ color: "#fbc500" }} />;
    default:
      return null;
  }
};

export default ReceiptAuditStatusIcon;
